interface MercadoPagoBasisTheoryChallengeData {
  url: string;
  creq: string;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** Validate the Purchase contract before any provider value reaches a form. */
function normalizeMercadoPagoBasisTheoryChallenge(
  value: unknown,
): MercadoPagoBasisTheoryChallengeData | undefined {
  if (!isRecord(value) || value.method !== 'POST' || !isRecord(value.parameters)) {
    return undefined;
  }

  return validateMercadoPagoBasisTheoryChallengeData({
    url: value.url,
    creq: value.parameters.creq,
  });
}

/** Validate challenge data at the form boundary without rebuilding a Purchase response. */
function validateMercadoPagoBasisTheoryChallengeData(
  value: unknown,
): MercadoPagoBasisTheoryChallengeData | undefined {
  if (!isRecord(value)) return undefined;
  const { url, creq } = value;
  if (typeof url !== 'string' || !url.trim() || typeof creq !== 'string' || !creq.trim()) {
    return undefined;
  }

  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.protocol !== 'https:' || parsedUrl.username || parsedUrl.password) {
      return undefined;
    }
    return { url: parsedUrl.href, creq };
  } catch {
    return undefined;
  }
}

export { normalizeMercadoPagoBasisTheoryChallenge, validateMercadoPagoBasisTheoryChallengeData };
export type { MercadoPagoBasisTheoryChallengeData };
